import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { MdFileDownload, MdUploadFile } from "react-icons/md";
import { RiCloseFill } from "react-icons/ri";

import '../../css/modal.css';
import { logout } from "../../actions/AppActions";
import { URL } from "../../variables";
import Attention from "../ReusableComponents/Attention";
import DefaultButton from "../ReusableComponents/DefaultButton";

const ModalQuestoesDocx = ({ showModal, setShowModal, saveQuestoes, onFinish }) => {
  const { t } = usePreferences();
  const token = useSelector((store) => store.AppReducer.token);
  const dispatch = useDispatch();
  const pollTimeout = useRef(null);

  const [docxFile, setDocxFile] = useState(null);
  const [docxValue, setDocxValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [msgErro, setMessageErro] = useState('');

  const clearPoll = () => {
    if (pollTimeout.current != null) {
      clearTimeout(pollTimeout.current);
      pollTimeout.current = null;
    }
  };

  const resetState = () => {
    clearPoll();
    setDocxFile(null);
    setDocxValue('');
    setMessage('');
    setMessageErro('');
  };

  const closeModal = () => {
    if (loading) {
      return;
    }

    resetState();
    setShowModal(false);
    if (onFinish) {
      onFinish();
    }
  };

  const downloadModel = (fileName) => {
    const link = document.createElement('a');
    link.href = `/${fileName}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const parseErrors = (resp) => {
    if (resp.errors != null) {
      return Object.values(resp.errors).join('\n');
    }
    if (resp.error != null) {
      return Array.isArray(resp.error) ? resp.error.join('\n') : resp.error;
    }
    return t('docx_error_process_file');
  };

  const pollJob = (id) => {
    fetch(`${URL}api/faculdade/get_questoes_prova_docx_job/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    }).then(async (responseLog) => {
      let resp = await responseLog.json();

      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token');
        dispatch(logout());
        return;
      }

      if (resp.errors != null || resp.error != null) {
        clearPoll();
        setLoading(false);
        setMessage('');
        setMessageErro(parseErrors(resp));
        return;
      }

      if (resp.status === 'Finalizado') {
        clearPoll();
        setLoading(false);
        setMessage('');
        setDocxFile(null);
        setDocxValue('');
        saveQuestoes(resp.questoes || []);
        return;
      }

      if (resp.status === 'Erro na execução') {
        clearPoll();
        setLoading(false);
        setMessage('');
        setMessageErro(resp.error_friendly || resp.error_message || t('docx_error_import_questions'));
        return;
      }

      setMessage(resp.mensagem || t('docx_status_creating_bank'));
      pollTimeout.current = setTimeout(() => pollJob(id), 15000);
    }).catch((err) => {
      console.log(err);
      clearPoll();
      setLoading(false);
      setMessage('');
      setMessageErro(t('docx_error_poll_job'));
    });
  };

  const uploadDocx = () => {
    if (docxFile == null) {
      setMessageErro(t('docx_error_select_file'));
      return;
    }

    let form = new FormData();
    form.append('questoes', docxFile);

    clearPoll();
    setLoading(true);
    setMessage(t('docx_status_uploading_file'));
    setMessageErro('');

    fetch(`${URL}api/faculdade/save_questoes_prova_docx`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: form
    }).then(async (responseLog) => {
      let resp = await responseLog.json();

      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token');
        dispatch(logout());
        return;
      }

      if (resp.errors != null || resp.error != null) {
        setLoading(false);
        setMessage('');
        setMessageErro(parseErrors(resp));
        return;
      }

      setMessage(t('docx_status_creating_bank'));
      pollJob(resp.job_id);
    }).catch((err) => {
      console.log(err);
      setLoading(false);
      setMessage('');
      setMessageErro(t('docx_error_upload_file'));
    });
  };

  useEffect(() => {
    if (showModal != true) {
      resetState();
    }

    return () => clearPoll();
  }, [showModal]);

  return (
    <Modal
      show={showModal == true}
      dialogClassName="modal-90w modal-width"
      backdrop={loading ? 'static' : true}
      keyboard={!loading}
      onHide={closeModal}>

      <Modal.Header closeButton={!loading} closeLabel=''>
        <Modal.Title>{t('docx_add_exam_questions_title')}<br /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
          <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setMessageErro('')}></button>
            <p style={{ marginBottom: 0, whiteSpace: 'pre' }}>{msgErro}</p>
          </div>
          <br />
        </div>}

        <InputGroup>
          <div className="flex fdcolumn flex1 margin-bottom" style={{ marginTop: '1rem' }}>
            <Form.Label>{t("label_docx_file")} <Attention /> </Form.Label>
            <div className="modern-file-upload">
              <input
                id="prova-questoes-docx-file"
                type="file"
                accept=".docx"
                value={docxValue}
                disabled={loading}
                className="modern-file-upload-input"
                onChange={(e) => {
                  setDocxFile(e.target.files[0]);
                  setDocxValue('');
                  setMessageErro('');
                }} />
              <label className="modern-file-upload-trigger" htmlFor="prova-questoes-docx-file">
                <MdUploadFile size={20} />
                <span>{t('docx_select_file')}</span>
              </label>
              {docxFile == null && <span className="modern-file-upload-empty">{t('docx_file_by_disciplines_description')}</span>}
            </div>

            {docxFile != null && <div className="selected-file-chip">
              <p><b>{t("label_selected_file")} </b>{docxFile.name}</p>
              {!loading && <Close onClick={() => setDocxFile(null)} style={{ cursor: 'pointer', width: '0.9rem', marginLeft: 3 }} />}
            </div>}
          </div>
        </InputGroup>

        <div className="import-instructions">
          <div>
            <b>{t("ui_padrao_3386172b")}</b>
            <p>{t('docx_instructions_intro')}</p>
          </div>
          <div className="import-instructions-grid">
            <div className="import-instructions-card">
              <strong>{t('docx_objective_questions_title')}</strong>
              <ul>
                <li>{t('docx_objective_question_number_instruction')}</li>
                <li>{t('docx_objective_alternatives_instruction')}</li>
                <li>{t('docx_correct_alternative_instruction')}</li>
              </ul>
            </div>
            <div className="import-instructions-card">
              <strong>{t('docx_group_questions_title')}</strong>
              <ul>
                <li>{t('docx_group_header_instruction')}</li>
                <li>{t('docx_group_children_instruction')}</li>
                <li>{t('docx_group_added_instruction')}</li>
              </ul>
            </div>
            <div className="import-instructions-card">
              <strong>{t('docx_discursive_questions_title')}</strong>
              <ul>
                <li>{t('docx_discursive_question_number_instruction')}</li>
                <li>{t('docx_discursive_no_alternatives_instruction')}</li>
                <li>{t('docx_metadata_optional_instruction')}</li>
              </ul>
            </div>
          </div>
          <div className="import-model-actions">
            <DefaultButton
              bg="secondary"
              icon={<MdFileDownload style={{ marginRight: 8 }} />}
              text={t('docx_download_objective_model')}
              onClick={() => downloadModel('Modelo_Questoes_Prova_Objetivas.docx')} />
            <DefaultButton
              bg="secondary"
              icon={<MdFileDownload style={{ marginRight: 8 }} />}
              text={t('docx_download_objective_group_model')}
              onClick={() => downloadModel('Modelo_Questoes_Prova_Objetivas_Conjunto.docx')} />
            <DefaultButton
              bg="secondary"
              icon={<MdFileDownload style={{ marginRight: 8 }} />}
              text={t('docx_download_discursive_model')}
              onClick={() => downloadModel('Modelo_Questoes_Prova_Dissertativas.docx')} />
          </div>
        </div>

        {message != '' && <div className="w100 inline-flex jcc margin-top-1 d-flex justify-content-center align-items-center">
          <CircularProgress size={24} />
          <p style={{ marginBottom: 0, marginLeft: 12 }}>{message}</p>
        </div>}

        {loading == false && <div className="w100 inline-flex jcsb margin-top-1">
          <DefaultButton
            bg="secondary"
            text={t("action_close")}
            icon={<RiCloseFill />}
            onClick={closeModal} />
          <DefaultButton
            type="button"
            disabled={docxFile == null}
            onClick={uploadDocx}
            bg={docxFile != null ? "confirm" : "secondary"}
            text={t("action_add")} />
        </div>}

        {loading == true && <div className="w100 inline-flex jcsb margin-top-1 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </div>}
      </Modal.Body>
    </Modal>
  );
};

export default ModalQuestoesDocx;
